import { TRADES_BLOTTER_PREFIX } from '@src/containers/Blotters/Trades/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy trades tabs into trades blotter panel params. */
export function migrateTradesBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyTradesTabs = config.tabs?.[TRADES_BLOTTER_PREFIX];
  if (legacyTradesTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyTradesTabs,
    blotterType: 'tradesBlotter',
  });
}
